import reducers from '../reducers';
import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { apiMiddleware } from 'redux-api-middleware';
import authMiddleware from './authMiddleware';

export default function configureStore(history, initialState) {
	const middleware = [authMiddleware, apiMiddleware, thunk, thunk]
	middleware.push(routerMiddleware(history));

	const createStoreWithMiddleware = applyMiddleware(...middleware)(createStore);
	const store = createStoreWithMiddleware(reducers, initialState);
	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		module.hot.accept('../reducers', () => {
			const nextReducer = require('../reducers');
			store.replaceReducer(nextReducer);
		})
	}

	return store
}


// WEBPACK FOOTER //
// ./src/stores/index.js